import React, { useMemo } from "react";
import { Inbox } from "lucide-react";
import { formatDueLabel, isOverdueDueLabel } from "../utils/taskDates";
import {
    PINNED_TRIAGE_VIEWS,
    tasksForTriagePin,
    triageCounts,
} from "../utils/taskTriage";

const TaskTriageInbox = ({
    tasks = [],
    pinId = "unassigned",
    onPinChange,
    assignOptions = [],
    onAssign,
    onView,
}) => {
    const counts = useMemo(() => triageCounts(tasks), [tasks]);
    const rows = useMemo(() => tasksForTriagePin(tasks, pinId), [tasks, pinId]);
    const activePin = PINNED_TRIAGE_VIEWS.find((pin) => pin.id === pinId) || PINNED_TRIAGE_VIEWS[0];

    return (
        <div className="task-triage">
            <div className="task-triage__pins" role="tablist" aria-label="Triage queues">
                {PINNED_TRIAGE_VIEWS.map((pin) => (
                    <button
                        key={pin.id}
                        type="button"
                        role="tab"
                        aria-selected={pinId === pin.id}
                        className={`task-triage__pin ${pinId === pin.id ? "is-active" : ""}`}
                        onClick={() => onPinChange?.(pin.id)}
                    >
                        {pin.label}
                        <span>{counts[pin.id] || 0}</span>
                    </button>
                ))}
            </div>

            <div className="flex items-center justify-between gap-2 mb-2">
                <p className="text-sm font-semibold text-ink">
                    {activePin.label} ({rows.length})
                </p>
            </div>

            {rows.length === 0 ? (
                <div className="rounded-lg border border-dashed border-line p-6 text-center text-ink-muted text-sm">
                    <Inbox size={18} className="inline-block mb-1 opacity-70" />
                    <p>Nothing in this queue.</p>
                </div>
            ) : (
                <div className="task-triage__list">
                    {rows.map((task) => {
                        const dueLabel = formatDueLabel(task);
                        return (
                            <div key={task.id} className="task-triage__row">
                                <button
                                    type="button"
                                    className="task-triage__title"
                                    onClick={() => onView?.(task)}
                                >
                                    <span className="truncate">{task.title || "Untitled"}</span>
                                    <span className="task-triage__meta">
                                        <span className="capitalize">{task.priority || "medium"}</span>
                                        {dueLabel ? (
                                            <span
                                                className={
                                                    isOverdueDueLabel(dueLabel) ? "text-error" : ""
                                                }
                                            >
                                                {dueLabel}
                                            </span>
                                        ) : (
                                            <span>No due</span>
                                        )}
                                    </span>
                                </button>
                                <label className="task-triage__assign">
                                    <select
                                        value={task.assign_to || ""}
                                        onChange={(e) => onAssign?.(task.id, e.target.value)}
                                        aria-label={`Assign ${task.title || "task"}`}
                                    >
                                        <option value="">Unassigned</option>
                                        {assignOptions.map((opt) => (
                                            <option key={opt.value} value={opt.value}>
                                                {opt.label.split(" (")[0]}
                                            </option>
                                        ))}
                                    </select>
                                </label>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default TaskTriageInbox;
